import API from 'utils/api';
import { onError } from 'utils/handlers';

export const baseURI = 'nominas/descuentos-carga-externa-archivo-ipejal-patronal-vivienda';

/**
 * GET Reporte IPEJAL Patronal y Vivienda (Fondo de Pensiones y Fondos de Vivienda)
 * @param {number} descuentoCargaExternaArchivoId
 * @returns {Promise<object[]>}
 */
export const getReporteIPEJALPatronalVivienda = async (descuentoCargaExternaArchivoId) => {
  try {
    const response = await API.get(`${baseURI}/${descuentoCargaExternaArchivoId}/`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};
